module.exports = __webpack_public_path__ + "tables/media/Package_outlined.a27e25b6.svg";